;(function (angular) {
  'use strict'

  angular
    .module('kilo.routes.inbox', [
      'kilo.routes.inbox.show',
      'kilo.routes.inbox.list'
    ])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  function RouteConfigurator ($stateProvider) {

    var parentState = {
      name: 'inbox',
      url: '/inbox',
      resolve: {},
      abstract: true
    }

    $stateProvider.state(parentState)
  }
})(window.angular)
